import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { cn } from '@/lib/utils';

const EASE = [0.22, 1, 0.36, 1];

/** Subtle editorial entrance: opacity + a small lift. Nothing bouncy. */
export const Reveal = ({
  children,
  className,
  delay = 0,
  y = 14,
  duration = 0.7,
  once = true,
  as = 'div',
}) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    return <div className={className}>{children}</div>;
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration, delay, ease: EASE }}
    >
      {children}
    </MotionTag>
  );
};

/** Staggered children helper. */
export const RevealGroup = ({ children, className, stagger = 0.07, delay = 0 }) => (
  <div className={cn(className)}>
    {React.Children.map(children, (child, i) => (
      <Reveal delay={delay + i * stagger} key={i}>
        {child}
      </Reveal>
    ))}
  </div>
);

export default Reveal;
